<template>
  <div class="relative" @keydown.esc="toggleModal()">
    <div class="mask" v-if="isOpen" @click.self="toggleModal()">
      <div class="modal" aria-live="polite">
        <button
          v-if="!withoutCancelBtn"
          tabindex="2"
          ref="close"
          class="absolute top-0 right-0 appearance-square"
          @click="toggleModal()"
          @keydown.tab.prevent="handleKeyPress('close', $event)"
          aria-label="Close"
        >
          <doe-icon icon="times" size="small" />
        </button>
        <h3 class="mb-4 block font-sans font-semibold leading-snug max-w-4xl subpixel-antialiased text-2xl text-blue-900" tabindex="-1" ref="modalHeadline">{{ headline }}</h3>
        <doe-paragraph :description="description" />


        <div v-if="withoutCancelBtn" class="actions">
          <button
            class="md:ml-2 appearance-primary"
            tabindex="1"
            ref="action"
            @click="toggleModal();$root.$emit('modal:primary')"
            @keydown.tab.prevent="handleKeyPress('action', $event)"
            :aria-label="$root.modalLabel"
          >
            Continue
          </button>
        </div>

        <div v-else class="actions">
          <button
            class="mb-4 md:mb-0 appearance-secondary"
            tabindex="1"
            ref="cancel"
            @click="cancelAction"
            @keydown.tab.prevent="handleKeyPress('cancel', $event)"
            v-show="cancellable"
            aria-label="Cancel"
          >
            Cancel
          </button>
          <button
            class="md:ml-2 appearance-primary"
            tabindex="1"
            ref="action"
            @click="toggleModal();$root.$emit('modal:primary')"
            @keydown.tab.prevent="handleKeyPress('action', $event)"
            :aria-label="$root.modalLabel"
          >
            {{ label }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DoeIcon from "@/components/icon/Icon";
import DoeParagraph from "@/components/typography/Paragraph";

export default {
  name: "DoeModal",
  components: {
    DoeIcon,
    DoeParagraph
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    headline: {
      type: String
    },
    description: {
      type: String
    },
    cancellable: {
      type: Boolean,
      default: false
    },
    withoutCancelBtn: {
      type: Boolean,
      default: false
    },
    label: {
      type: String
    }
  },
  watch: {
    isOpen: function (newVal) {
      if (newVal) {
        this.setFocus();
      }
    },
    isLoading: function(newVal) {
      if (!newVal && this.isOpen) {
        this.setFocus();
      }
    }
  },
  methods: {
    handleAction(action) {
      this.$root.modalIsOpen = false;
      this.$emit(action);
    },
    handleKeyPress(name, e) {
      if (e.shiftKey) {
        if (name === "cancel") {
          this.$refs.close.focus();
        }
        if (name === "action" && this.cancellable) {
          this.$refs.cancel.focus();
        }
        if (name === "action" && !this.cancellable) {
          this.$refs.close.focus();
        }
        if (name === "close") {
          this.$refs.action.focus();
        }
      } else {
        if (name === "cancel") {
          this.$refs.action.focus();
        }
        if (name === "action") {
          this.$refs.close.focus();
        }
        if (name === "close" && this.cancellable) {
          this.$refs.cancel.focus();
        }
        if (name === "close" && !this.cancellable) {
          this.$refs.action.focus();
        }
      }      
    },
    toggleModal() {
      this.$root.modalIsOpen = !this.$root.modalIsOpen;
      if(document.getElementById(this.$store.getters.getButtonId)) {
        document.getElementById(this.$store.getters.getButtonId).focus();
      }      
    },
    cancelAction() {
      this.toggleModal();
      this.$root.$emit('modal:secondary');
    },
    setFocus() {
      document.activeElement.blur();
      this.$nextTick(() => {
        this.$refs.modalHeadline.focus();
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.mask {
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
}
.modal {
  @apply absolute bg-white border border-blue-900 rounded p-6 w-full max-w-3xl z-50;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.actions {
  @apply mt-6 text-right;
}
@screen lg {
  h3 {
    @apply leading-snug text-2xl;
  }
}

button {
  @apply cursor-pointer text-blue-900 font-sans font-semibold select-none w-full;
  svg {
    @apply fill-current;
  }
  @screen md {
    @apply w-auto;
  }
}
.appearance-primary,
.appearance-secondary {
  @apply py-2 px-3 rounded border-2 leading-snug py-2 text-base;
}
.appearance-primary {
  @apply text-white bg-red-900 border-red-900;
  &:focus {
    outline: 1px solid #ce0037;
    outline-offset: 3px;
  }
}
.appearance-secondary {
  @apply text-blue-900 bg-gray-400 border-blue-900;
  &:focus {
    outline: 1px solid #041e42;
    outline-offset: 3px;
  }
}
.appearance-square {
  @apply px-0 min-w-auto text-center;
  height: 44px;
  width: 44px;
}
</style>
